export const propagandas = {
    noticia: [
      { tipo: "banner", imagem: "/img/propaganda-banner.jpg", link: "/" },
      { tipo: "google", id: "ca-pub-XXXXXXXXXXXXXXXX", slot: "1234567890" },
      { tipo: "banner", imagem: "/banners/empresa-x.jpg", link: "https://empresa-x.com" },
    ]
  };
  
